import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { useKeenSlider } from 'keen-slider/react';
import { useCallback, useState, useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { Avatar } from '@/components/Avatar/Avatar';
import { WebviewModal } from '@/components/Message/Webview/WebviewModal/WebviewModal';
import { useController } from '@/hooks/useController';
import { useSocket } from '@/hooks/useSocket';
import { isMobileSelector } from '@/state/session';
import { CarouselCard } from './Card';
import styles from './Carousel.module.scss';
const arrowIcon = (_jsx("svg", { width: "6", height: "10", viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M5 1L1 5L5 9", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }));
export const Carousel = ({ avatar, message, disabled, onButtonClick, }) => {
    const isMobile = useRecoilValue(isMobileSelector);
    const { notifyWebviewClosed, notifyWebviewOpened } = useController();
    const { sendMessage } = useSocket();
    const [showWebview, setShowWebview] = useState(false);
    const [webview, setWebview] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const options = useMemo(() => ({
        slides: {
            spacing: 8,
            perView: !isMobile ? 1 : 1.25,
        },
        initial: 0,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
    }), [isMobile]);
    const [ref, slider] = useKeenSlider(options);
    const handlePostback = useCallback((text, label) => {
        sendMessage({ text: text === null || text === void 0 ? void 0 : text.trim(), label });
    }, [sendMessage]);
    const handleWebviewClose = useCallback(() => {
        setShowWebview(false);
        notifyWebviewClosed();
    }, [notifyWebviewClosed]);
    const handleWebviewClick = useCallback((button) => {
        setWebview(button);
        notifyWebviewOpened();
        setShowWebview(true);
    }, [notifyWebviewOpened]);
    return (_jsxs(_Fragment, { children: [webview && (_jsx(WebviewModal, { webview: webview, showModal: showWebview, avatar: avatar, handleCloseModal: handleWebviewClose })), _jsxs("li", { className: styles.bubble, children: [_jsx(Avatar, { avatar: avatar }), _jsxs("div", { className: cn(styles.container, { [styles.isMobile]: isMobile }), children: [_jsx("div", { children: _jsx("div", { ref: ref, className: cn(styles.slider, 'keen-slider'), children: message.cards.map((card) => (_jsx(CarouselCard, { card: card, className: "keen-slider__slide", onPostback: handlePostback, disabled: disabled, onWebviewClick: handleWebviewClick, onButtonClick: onButtonClick }, `${card.title}-${card.media.url}`))) }) }), _jsxs("div", { className: styles.legend, children: [currentSlide + 1, "/", message.cards.length] })] }), currentSlide > 0 && (_jsx("button", { className: cn(styles.arrowBtn, styles.arrowBtnLeft), type: "button", onClick: () => { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.prev(); }, children: arrowIcon })), currentSlide < message.cards.length - 1 && (_jsx("button", { className: cn(styles.arrowBtn, styles.arrowBtnRight), type: "button", onClick: () => { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.next(); }, children: arrowIcon }))] })] }));
};
